import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FocusTrap from 'focus-trap-react';
import classNames from 'classnames';
import Filter from './filter';
import DeliveryOptionFilters from './delivery-option-filters';
import SelectedOptions from './selected-options';
import ModalHeader from './modal-header';
import MobileSort from './mobile-sort';
import { getViewport } from '../_utils/hoc/with-viewport-size';

const Modal = ({
  category,
  delivery_options: deliveryOptions,
  facets,
  favouriteFilters,
  filters,
  handleModalFiltersHide,
  hideModalFilters,
  onClearAllFilters,
  onDeliveryOptionSelected,
  onFilterOptionSelected,
  selectedDeliveryOptions,
  selectedFilterCount,
  selected_filters: selectedFilters,
  onSortChange,
  sortValue
}) => {
  const [isClient, setIsClient] = React.useState(false);

  React.useEffect(() => {
    setIsClient(true);
  }, []);
  return (
    <FocusTrap active={!hideModalFilters} focusTrapOptions={{ initialFocus: ".close-button", returnFocusOnDeactivate: true }}>
      <div
        role="dialog"
        aria-labelledby="All Filters"
        aria-hidden={hideModalFilters}>
        <div
          className={classNames(
            'modal-background d-flex align-items-center h-100 w-100 position-fixed',
            { invisible: hideModalFilters }
          )}
          onClick={handleModalFiltersHide}
        ></div>
        <div
          className={classNames('filter-modal', { 'd-none': hideModalFilters })}>
          <ModalHeader
            isFilterSelected={selectedFilterCount > 0}
            clickModalFilterHide={handleModalFiltersHide}
          />

          <div className="filters-modal-body">
            {selectedFilterCount > 0 && (<SelectedOptions
              selectedDeliveryOptions={selectedDeliveryOptions || []}
              selectedFilters={selectedFilters}
              availableFilters={filters}
              onClearClick={onFilterOptionSelected}
              showSelectedOptions={selectedFilters.length > 0}
              deliveryOptions={deliveryOptions}
              onDeliveryOptionClicked={onDeliveryOptionSelected}
              selectedFilterCount={selectedFilterCount}
              onClearAllFilters={onClearAllFilters}
            />
            )}
            <ul className="ml-2 mt-3 list-unstyled menu-ul">
              {isClient && getViewport().isMobile && (
                <li className="ml-2 mt-3 modal-li">
                  <MobileSort value={sortValue} onChange={onSortChange} />
                </li>
              )}
              <div>
                <DeliveryOptionFilters
                  options={deliveryOptions}
                  facets={(facets || {})['faceted_delivery_options']}
                  selected_options={selectedDeliveryOptions || []}
                  filter_name="deliveryOptions"
                  modal={true}
                />
              </div>
              {filters.map((filter) => {
                if ((facets || {})['filter_' + filter.key].length === 0) {
                  return null;
                }
                return (
                  <Filter
                    {...filter}
                    key={filter.key}
                    name={filter.key}
                    title={filter.label}
                    options={filter.options}
                    category={category}
                    facets={(facets || {})['filter_' + filter.key]}
                    selected_options={selectedFilters[filter.key] || []}
                    filter_name={filter.key}
                    modal={true}
                  />
                );
              })}
              {favouriteFilters}
            </ul>
          </div>
          <div className="card-footer filters-modal-footer justify-content-center">
            <button
              className="btn btn-pill btn-primary w-100 done-button"
              onClick={handleModalFiltersHide}>
              Done
            </button>
          </div>
        </div>
      </div>
    </FocusTrap>
  );
};

Modal.propTypes = {
  hideModalFilters: PropTypes.bool,
  handleModalFiltersHide: PropTypes.func,
  filters: PropTypes.array,
  facets: PropTypes.object,
  selectedFilters: PropTypes.object,
  deliveryOptions: PropTypes.array,
  selectedDeliveryOptions: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
  ]),
  sortValue: PropTypes.string,
  onFilterOptionSelected: PropTypes.func,
  onSortChange: PropTypes.func,
  selectedFilterCount: PropTypes.number,
  onDeliveryOptionSelected: PropTypes.func,
};

export default Modal;
